import debounceEvent from '@redux-beacon/debounce-event';
import GoogleTagManager from 'middlewares/googleTagManager';
import { userProfileActions } from 'features/userProfile';
import { createMiddleware } from 'redux-beacon';
import { addMiddleware } from 'redux-dynamic-middlewares';


const favoritesSaved = (action) => action.payload.housingProductType.getFavoriteGoogleAnalyticsEvent();

const eventsMapper = (action) => {
    switch (action.type) {
        case userProfileActions.saveFavoriteFulfilled.type:
            return debounceEvent(100, favoritesSaved);
        default:
            return [];
        }
};
      
const googleTagManager = new GoogleTagManager();
const searchResultsGoogleTagManagerMiddleware = createMiddleware(eventsMapper, googleTagManager.getTarget());
addMiddleware(searchResultsGoogleTagManagerMiddleware);        